import PropTypes from 'prop-types';
import GetFreeModal from '@components/get-free-modal';
import { CONTENT_ROOT_ID } from '@constants';
import { StyledAppContainer, StyledContentArea } from '@styles/app.styles';
import Scanner from '../../scanner';

const AppWrapper = ({ children }) => {
	return (
		<StyledAppContainer>
			<StyledContentArea id={CONTENT_ROOT_ID}>{children}</StyledContentArea>

			<Scanner />

			<GetFreeModal />
		</StyledAppContainer>
	);
};

AppWrapper.propTypes = {
	children: PropTypes.node,
};

export default AppWrapper;
